// DebugPanel.jsx
import React from 'react';

const DebugPanel = ({ debugInfo }) => (
  <div className="bg-gray-50 rounded-lg p-4 mb-4 text-sm">
    <h3 className="font-semibold text-gray-900 mb-2">Debug Information</h3>
    <div className="space-y-2">
      <div>
        <strong>Status:</strong> 
        <span className={`ml-2 ${debugInfo.status.includes('Error') ? 'text-red-600' : 'text-gray-600'}`}>
          {debugInfo.status}
        </span>
      </div>
      <div>
        <strong>Data Loaded:</strong>
        <ul className="ml-4 mt-1 space-y-1">
          <li className="flex items-center">
            <span className={`mr-2 ${debugInfo.courseDataLoaded.status ? 'text-green-600' : 'text-red-600'}`}>
              {debugInfo.courseDataLoaded.status ? '✓' : '×'}
            </span>
            {debugInfo.courseDataLoaded.filename}
          </li>
          <li className="flex items-center">
            <span className={`mr-2 ${debugInfo.instructionsLoaded.status ? 'text-green-600' : 'text-red-600'}`}>
              {debugInfo.instructionsLoaded.status ? '✓' : '×'}
            </span>
            {debugInfo.instructionsLoaded.filename}
          </li>
        </ul>
      </div>
      {debugInfo.apiStats && (
        <div>
          <strong>Last Query Stats:</strong>
          <ul className="ml-4 mt-1 space-y-1 text-gray-600">
            <li>Message ID: {debugInfo.apiStats.idMessage}</li>
            <li>Model: {debugInfo.apiStats.model}</li>
            <li>Timestamp: {debugInfo.apiStats.timestamp}</li>
            <li>Processing Time (s): {debugInfo.apiStats.processingTime}</li>
            <li>Prompt Tokens: {debugInfo.apiStats.promptTokens || '-'}</li>
            <li>Completion Tokens: {debugInfo.apiStats.completionTokens || '-'}</li>
            <li>Total Tokens: {debugInfo.apiStats.totalTokens || '-'}</li>
            <li>Estimated Cost: {debugInfo.apiStats.estimatedCost}</li>
          </ul>
        </div>
      )}
    </div>
  </div>
);

export default DebugPanel;